import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextCropper from '@omilia/text-cropper';

import Button from 'components/Button';
import EmptyView from 'components/EmptyView';

const SContainer = styled.div`
  width: 390px;
`;

const STextCropper = styled(TextCropper)`
  width: 370px;
`;

const UnitsSearchResult = ({
  items,
  searchTerm,
  unitName,
  showAll,
  className,
}) => (
  <EmptyView className={className}>
    <span>You searched for {unitName} named:&nbsp;</span>

    <SContainer>
      &quot;
      <STextCropper
        key={searchTerm}
        data-test="searchTerm"
        text={`${searchTerm}`}
      />
      &quot;.
    </SContainer>

    <span data-test="numberOfMatched">{items.length} matches</span>

    <Button isLink data-test="reset-button" onClick={showAll}>
      Show all
    </Button>
  </EmptyView>
);

UnitsSearchResult.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  searchTerm: PropTypes.string.isRequired,
  showAll: PropTypes.func.isRequired,
  unitName: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default UnitsSearchResult;
